var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightmanifest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 470,
    viewBox: "0 0 470 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.711 4.69337C433.151 -2.45832 449.677 -1.11738 461.29 8.71619C471.117 20.3377 472.457 36.876 465.31 58.331C458.164 79.7861 446.104 99.0062 429.131 115.992L375.196 169.964L428.796 403.288C429.912 407.535 428.572 411.222 424.776 414.351L381.896 446.534C380.333 447.875 378.211 448.545 375.531 448.545C374.638 448.545 373.856 448.433 373.186 448.21C369.836 447.539 367.491 445.751 366.151 442.846L272.687 272.546L185.923 359.372L203.678 424.408C204.795 428.207 203.901 431.671 200.998 434.8L168.838 466.983C166.828 468.994 164.26 470 161.133 470H160.463C157.113 469.553 154.434 468.1 152.424 465.642L89.1092 381.163L4.6901 317.803C2.23345 316.239 0.781804 313.669 0.335142 310.093C0.111811 307.187 1.1168 304.394 3.35011 301.712L35.5098 269.194C37.5197 267.183 40.088 266.177 43.2147 266.177C44.5547 266.177 45.448 266.289 45.8947 266.512L110.884 284.28L197.648 197.454L27.4699 103.923C24.3432 102.135 22.4449 99.4532 21.7749 95.8774C21.3282 92.3015 22.3332 89.2844 24.7899 86.826L67.6694 43.9159C70.7961 41.0105 74.146 40.1166 77.7193 41.234L300.492 94.5364L354.091 40.8988C371.065 23.9135 390.271 11.8451 411.711 4.69337Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 470,
    height: 470,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightmanifest);
export default __webpack_public_path__ + "static/media/flightmanifest.a1c0436a659b304014cd38bb3eb5642e.svg";
export { ForwardRef as ReactComponent };